import { Text, styled } from '@volkswagen-onehub/components-core';
import { convertBreakpointsToMediaQueries } from './modules/utils/themeUtils';
import { transformSizes } from './modules/components/Box/Box.styles';
import { BoxBaseProps } from './modules/components/Box/Box';

interface DisclaimerTextProps {
  color?: string;
  b960?: BoxBaseProps;
}

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${convertBreakpointsToMediaQueries({
    b1280: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
    },
  })}
`;

export const LinkText = styled(Text)(
  ({ theme }) => `
  color: ${theme.colors.link.default};
  text-decoration: inherit;
`);

export const DisclaimerText = styled(Text)<DisclaimerTextProps & BoxBaseProps>(
  ({ theme, color, b960, marginBottom }) => `
  margin-top: ${theme.size.static350};
  color: ${color ?? theme.colors.content.secondary};
  margin-bottom: ${marginBottom ? theme.size[marginBottom] : 0};
  line-height: 20px;
  ${convertBreakpointsToMediaQueries({
    b960: transformSizes(theme, {
      marginTop: b960?.marginTop ?? 'static515',
    }),
  })})
`
);
